import { useEffect, useState } from "react";
import Web3 from "web3";
import { useAccount } from "wagmi";
import { getConnectorClient } from "@wagmi/core";
import { wagmiConfig } from "../wagmiConfig";
import { getWeb3NoAccount } from "../utils/web3";

/**
 * Returns a web3 instance backed by the connected wallet.
 * Uses getConnectorClient (wagmi v2 official API) to get the viem WalletClient,
 * then wraps it as an EIP-1193 provider for web3.js.
 * Falls back to read-only RPC when no wallet is connected.
 */
const useWeb3 = () => {
  const { isConnected } = useAccount();
  const [web3, setWeb3] = useState(getWeb3NoAccount());

  useEffect(() => {
    if (!isConnected) {
      setWeb3(getWeb3NoAccount());
      return;
    }

    getConnectorClient(wagmiConfig)
      .then((client) => {
        // Wrap the viem WalletClient as an EIP-1193 provider for web3.js v1
        const eip1193 = {
          request: ({ method, params }) =>
            client.request({ method, params }),
          on: () => {},
          removeListener: () => {},
        };
        setWeb3(new Web3(eip1193));
      })
      .catch(() => {
        // Fallback: use window.ethereum directly if available (MetaMask)
        if (window.ethereum) {
          setWeb3(new Web3(window.ethereum));
        } else {
          setWeb3(getWeb3NoAccount());
        }
      });
  }, [isConnected]);

  return web3;
};

export default useWeb3;
